// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__2PKz7","active":"tooltip_active__2k4G5"};